// extracted by mini-css-extract-plugin
export default {"atlas":"index_atlas_w3zPI","pic":"index_pic_GX3Ul","txt":"index_txt_tBnVO","pagenum":"index_pagenum_mV-jz","num":"index_num_U57CC","title":"index_title_1WME1"};